import React, { Component } from "react";
import DataTable from "react-data-table-component";
import ContentContainer from "../../../containers/UI/ContentContainer/ContentContainer"
import LicenseModal from "./LicenseModal/LicenseModal"
import GenerateLicense from "./GenerateLicense/GenerateLicense"
import FilterModal from "../CustomerFilterModal/FilterModal"
import { ReactComponent as FilterIcon } from "../CustomerFilterModal/Filter.svg"
import axios from "../../../axios"
import classes from "./licenses.css"
import filterClass from "../CustomerFilterModal/FilterRow.css"


class Fleet extends Component {

  state = {
    licenses: [],
    filteredLicenses: [],
    showLicenseModal: false,
    showGenerateModal: false,
    showFilterModal: false,
    selectedLicense: {},
    filteredCustomer: "all-customers",
    filteredGateway: "all-gateways",
    customerOptions: [],
    gatewayOptions: [],
  }

  columns = [
    { name: "Gateway name", selector: "gateway.trivialName", sortable: true, left: true, style: { fontSize: "14px" }},
    { name: "Serial number", selector: "gateway.serialNumber", sortable: true, left: true, style: { fontSize: "14px" }},
    { name: "License type", selector: "licenseType", sortable: true, left: true, style: { fontSize: "14px" }, format: row => this.formatLicenseType(row.licenseType) },
    { name: "Customer", selector: "gateway.customer.name", sortable: true, left: true, style: { fontSize: "14px" }},
    { name: "Generation date", selector: "startDate", sortable: true, left: true, style: { fontSize: "14px" }, format: (row, index) => { return this.formatDate(row.startDate) }},
  ]

  componentDidMount() {
    axios.get("/license/all").then(response => {
      if (response.data) {

        // Construct customer options for filtering
        let customers = {}
        response.data.forEach(license => {
          let customer = license.gateway.customer
          if (!(customer._id in customers)) {
            customers[customer._id] = { value: customer._id, label: customer.name }
          }
        })

        // Construct gateway options for filtering
        let gateways = {}
        response.data.forEach(license => {
          let gateway = license.gateway
          if (!(gateway._id in gateways)) {
            gateways[gateway._id] = {
              value: gateway._id,
              label: gateway.serialNumber + " - " + gateway.trivialName,
              customerId: gateway.customer._id
            }
          }
        })

        this.setState({
          licenses: response.data,
          filteredLicenses: response.data,
          customerOptions: Object.values(customers),
          gatewayOptions: Object.values(gateways)
        })
      }
    })
  }

  displayLicenseModal = (shouldBeShown, license) => {
    this.setState({ showLicenseModal: shouldBeShown, selectedLicense: license })
  }

  closeGeneratorModal = () => {
    this.setState({ showGenerateModal: false })
    // Update license list
    axios.get("/license/all").then(response => {
      if (response.data) {
        const filteredLicenses = this.applyFilters(response.data, this.state.filteredCustomer, this.state.filteredGateway)
        this.setState({ licenses: response.data, filteredLicenses })
      }
    })
  }

  // Apply both customer and gateway filters
  applyFilters = (licenses, customerID, gatewayID) => {
    let filtered = licenses

    if (customerID !== "all-customers") {
      filtered = filtered.filter(license => license.gateway.customer._id === customerID)
    }

    if (gatewayID !== "all-gateways") {
      filtered = filtered.filter(license => license.gateway._id === gatewayID)
    }

    return filtered
  }

  updateFilter = (customerID, gatewayID) => {
    const filteredLicenses = this.applyFilters(this.state.licenses, customerID, gatewayID)
    this.setState({
      filteredCustomer: customerID,
      filteredGateway: gatewayID,
      filteredLicenses
    })
  }

  // Check if any filter is active
  isFiltered = () => {
    return this.state.filteredCustomer !== "all-customers" || this.state.filteredGateway !== "all-gateways"
  }

  render() {
    return (
      <ContentContainer title="Licenses">

        <div className={filterClass.buttonRow}>
          <button className={this.isFiltered() ? filterClass.filtered : filterClass.unfiltered} onClick={() => this.setState({ showFilterModal: true })}>
            {this.isFiltered() ? "Filtered" : "Filter"}
            <FilterIcon fill={this.isFiltered() ? "#FF6315" : "black"} className={filterClass.filterIcon} />
          </button>
          <button onClick={() => this.setState({ showGenerateModal : true })} className={classes.addButton}>Generate license</button>
        </div>

        <DataTable
          columns={this.columns}
          data={this.state.filteredLicenses}
          noHeader={true}
          pagination={true}
          highlightOnHover={true}
          striped={true}
          defaultSortField={"startDate"}
          defaultSortAsc={true}
          customStyles={{
            headCells: { style: { fontWeight: "bold", fontSize: "15px" }}
          }}
          onRowClicked={(license) => this.displayLicenseModal(true, license)}
        />

        {this.state.showLicenseModal && <>
        <LicenseModal
          shouldShow={this.state.showLicenseModal}
          license={this.state.selectedLicense}
          formatDate={this.formatDate}
          closeModal={() => this.displayLicenseModal(false, {})}/>
        </>}

        {this.state.showGenerateModal && <>
        <GenerateLicense
          shouldShow={this.state.showGenerateModal}
          formatDate={this.formatDate}
          closeModal={this.closeGeneratorModal}/>
        </>}


        {this.state.showFilterModal && <>
          <FilterModal
            shouldShow={this.state.showFilterModal}
            filteredCustomer={this.state.filteredCustomer}
            filteredGateway={this.state.filteredGateway}
            customerOptions={this.state.customerOptions}
            gatewayOptions={this.state.gatewayOptions}
            applyFilter={(customerID, gatewayID) => this.updateFilter(customerID, gatewayID)}
            closeModal={() => this.setState({ showFilterModal: false })}/>
        </>}
      </ContentContainer>
    );
  }


  // MARK: - Date format helper
  formatDate = (epoch) => {
    // Create date
    var date = new Date(0)
    date.setUTCSeconds(epoch)
    // Format properly
    return date.toLocaleDateString("en-us", { year: "numeric", month: "long", day: "numeric"})
  }

  formatLicenseType = (type) => {
    switch (type) {
      case "master":            return "Concentrator"
      case "slave":             return "Forwarder"
      case "knx-iot-router":    return "KNX IoT Router"
      case "knx-lora-gateway":  return "KNX LoRa gateway"
      case "knx-lora-forwarder":return "KNX LoRa forwarder"
      case "evolution":         return "Evolution plug-in"
      default:                  return "Concentrator"
    }
  }
}

export default Fleet;
